module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_c('crumbs', [_c('i', {
    staticClass: "icon-stack2"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.multiLanguage.crumbs.authList))])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('authMtable', {
    attrs: {
      "thData": _vm.thData,
      "trData": _vm.trData,
      "multiLanguage": _vm.multiLanguage,
      "handle": _vm.handle
    },
    on: {
      "deleteList": _vm.deleteList,
      "refresh": _vm.refresh,
      "addRefresh": _vm.tableAjax
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b4f89ba4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/authList.vue
// module id = 1135
// module chunks = 1